import { render, staticRenderFns } from "./DashboardEmbedView.vue?vue&type=template&id=9bce3cde&scoped=true&"
import script from "./DashboardEmbedView.vue?vue&type=script&lang=js&"
export * from "./DashboardEmbedView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEmbedView.vue?vue&type=style&index=0&id=9bce3cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bce3cde",
  null
  
)

export default component.exports